import { replaceUUID } from '@thesavingsgroup/utils/replaceUUID';

import { BuildHttpFingerprintProps } from '../types/BuildHttpFingerprintProps';

/**
 * Vendor-neutral fingerprint builder for HTTP request failures.
 *
 * Groups events by endpoint shape (method + UUID-stripped URL + HTTP
 * status or error code) so a single failing route does not splinter into
 * thousands of unique issues keyed off query strings or path IDs.
 */
export const buildHttpFingerprint = ({
  errorCode = '',
  errorRequestMethod = '',
  errorRequestUrl,
  errorResponseStatus = '',
}: BuildHttpFingerprintProps): string[] => [
  'http',
  errorRequestMethod.toLowerCase(),
  replaceUUID(errorRequestUrl),
  // Prefer HTTP status - fall back to the error code when there is no response.
  String(errorResponseStatus || errorCode),
];
